var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Influencer = /** @class */ (function () {
    function Influencer() {
    }
    return Influencer;
}());
export { Influencer };
var InfluencerDetail = /** @class */ (function () {
    function InfluencerDetail() {
    }
    return InfluencerDetail;
}());
export { InfluencerDetail };
var ChannelAudienceKPI = /** @class */ (function () {
    function ChannelAudienceKPI() {
    }
    return ChannelAudienceKPI;
}());
export { ChannelAudienceKPI };
var PerformanceGlobalKPI = /** @class */ (function () {
    function PerformanceGlobalKPI() {
    }
    return PerformanceGlobalKPI;
}());
export { PerformanceGlobalKPI };
var InfluencerChannel = /** @class */ (function () {
    function InfluencerChannel() {
    }
    return InfluencerChannel;
}());
export { InfluencerChannel };
var Platform = /** @class */ (function () {
    function Platform() {
    }
    return Platform;
}());
export { Platform };
var InfluencerPost = /** @class */ (function () {
    function InfluencerPost() {
    }
    return InfluencerPost;
}());
export { InfluencerPost };
var GaugeCircleChartData = /** @class */ (function () {
    function GaugeCircleChartData() {
    }
    return GaugeCircleChartData;
}());
export { GaugeCircleChartData };
var ProgressBar = /** @class */ (function () {
    function ProgressBar() {
    }
    return ProgressBar;
}());
export { ProgressBar };
var ContentPieChart = /** @class */ (function () {
    function ContentPieChart() {
    }
    return ContentPieChart;
}());
export { ContentPieChart };
var PieChartValue = /** @class */ (function () {
    function PieChartValue() {
    }
    return PieChartValue;
}());
export { PieChartValue };
var PieChartData = /** @class */ (function () {
    function PieChartData() {
    }
    return PieChartData;
}());
export { PieChartData };
var Exposure = /** @class */ (function () {
    function Exposure() {
    }
    return Exposure;
}());
var TopExposure = /** @class */ (function (_super) {
    __extends(TopExposure, _super);
    function TopExposure(author, influencerId, relativePath, url, urlHash, date, picture, title, value, platform) {
        if (author === void 0) { author = null; }
        if (influencerId === void 0) { influencerId = null; }
        if (relativePath === void 0) { relativePath = null; }
        if (url === void 0) { url = null; }
        if (urlHash === void 0) { urlHash = null; }
        if (date === void 0) { date = null; }
        if (picture === void 0) { picture = null; }
        if (title === void 0) { title = null; }
        if (value === void 0) { value = null; }
        if (platform === void 0) { platform = null; }
        var _this = _super.call(this) || this;
        _this.author = author;
        _this.influencer_id = influencerId;
        _this.relativepath = relativePath;
        _this.url = url;
        _this.urlHash = urlHash;
        _this.title = title;
        _this.value = value;
        _this.platform = platform;
        _this.date = date;
        _this.picture = picture;
        return _this;
    }
    return TopExposure;
}(Exposure));
export { TopExposure };
var BestPerformingExposure = /** @class */ (function (_super) {
    __extends(BestPerformingExposure, _super);
    function BestPerformingExposure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BestPerformingExposure;
}(Exposure));
export { BestPerformingExposure };
var AddInfluencerGroup = /** @class */ (function () {
    function AddInfluencerGroup() {
        this.influencerList = [];
    }
    return AddInfluencerGroup;
}());
export { AddInfluencerGroup };
var AddPostToProject = /** @class */ (function () {
    function AddPostToProject() {
        this.posts = [];
    }
    return AddPostToProject;
}());
export { AddPostToProject };
var PlatformReach = /** @class */ (function () {
    function PlatformReach() {
    }
    return PlatformReach;
}());
export { PlatformReach };
export var InfluencerIgStoryLoadingStatus;
(function (InfluencerIgStoryLoadingStatus) {
    InfluencerIgStoryLoadingStatus["PENDING"] = "PENDING";
    InfluencerIgStoryLoadingStatus["NO_STORY"] = "NO_STORY";
    InfluencerIgStoryLoadingStatus["PROCESSING"] = "PROCESSING";
    InfluencerIgStoryLoadingStatus["DONE"] = "DONE";
    InfluencerIgStoryLoadingStatus["ERROR"] = "ERROR";
})(InfluencerIgStoryLoadingStatus || (InfluencerIgStoryLoadingStatus = {}));
var InfluencerInfo = /** @class */ (function () {
    function InfluencerInfo() {
    }
    return InfluencerInfo;
}());
export { InfluencerInfo };
export var ContactPermissionStatus;
(function (ContactPermissionStatus) {
    ContactPermissionStatus["UNDEFINED"] = "UNDEFINED";
    ContactPermissionStatus["REQUESTED"] = "REQUESTED";
    ContactPermissionStatus["ACCEPTED"] = "ACCEPTED";
    ContactPermissionStatus["REJECTED"] = "REJECTED";
})(ContactPermissionStatus || (ContactPermissionStatus = {}));
var InfluencerConfirmationForm = /** @class */ (function () {
    function InfluencerConfirmationForm(fullName, email) {
        this.fullName = fullName;
        this.email = email;
    }
    return InfluencerConfirmationForm;
}());
export { InfluencerConfirmationForm };
export var RequestInfluencerType;
(function (RequestInfluencerType) {
    RequestInfluencerType["CAMPAIGN_INVITATION"] = "CAMPAIGN_INVITATION";
    RequestInfluencerType["CONTACT_PERMISSION"] = "CONTACT_PERMISSION";
})(RequestInfluencerType || (RequestInfluencerType = {}));
var ChannelFollowers = /** @class */ (function () {
    function ChannelFollowers() {
        this.channels = [];
    }
    return ChannelFollowers;
}());
export { ChannelFollowers };
var ChannelFollowersInfluencer = /** @class */ (function () {
    function ChannelFollowersInfluencer() {
    }
    return ChannelFollowersInfluencer;
}());
export { ChannelFollowersInfluencer };
var ChannelFollowerItem = /** @class */ (function () {
    function ChannelFollowerItem() {
    }
    return ChannelFollowerItem;
}());
export { ChannelFollowerItem };



// WEBPACK FOOTER //
// ./src/models/influencer.ts.pre-build-optimizer.js